import React from 'react';

function guvenEtiketi(confidence) {
  const level = String(confidence || '').toUpperCase();
  if (level === 'HIGH') return 'YÜKSEK';
  if (level === 'MEDIUM') return 'ORTA';
  if (level === 'LOW') return 'DÜŞÜK';
  return String(confidence || 'DÜŞÜK');
}

export default function ConfidenceSampleBadge({ confidence = 'DÜŞÜK', sampleSize = 0 }) {
  return (
    <span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[10px] font-bold text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
      Güven: {guvenEtiketi(confidence)} | Örneklem: {Number(sampleSize || 0).toLocaleString('tr-TR')}
    </span>
  );
}
